import { Borders, Color, ExpressionRuleType, Fill, Font } from "exceljs";

export const whiteColor: Partial<Color> = { argb: "FFFFFFFF" };
export const blackColor: Partial<Color> = { argb: "FF000000" };

/** BORDAS */
export const borderExpressionStyle: ExpressionRuleType[] = [
  {
    type: "expression",
    formulae: ["1"],
    priority: 0,
    style: {
      border: {
        top: { style: "thin", color: whiteColor },
        bottom: { style: "thin", color: whiteColor },
        left: { style: "thin", color: whiteColor },
        right: { style: "thin", color: whiteColor },
      },
    },
  },
];

export const borderThickStyle: Partial<Borders> = {
  top: { style: "thin", color: whiteColor },
  bottom: { style: "thin", color: whiteColor },
  left: { style: "medium", color: whiteColor },
  right: { style: "medium", color: whiteColor },
};

export const borderThinStyle: Partial<Borders> = {
  top: { style: "thin", color: whiteColor },
  bottom: { style: "thin", color: whiteColor },
  left: { style: "thin", color: whiteColor },
  right: { style: "thin", color: whiteColor },
};

/** CORES */
export const fillLightGreen: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFC4CF7C" },
};

export const fillLighterGreen: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD6DBB0" },
};

export const fillGreen: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFABC200" },
};

export const fillLightGray: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFEFEFEF" },
};

export const fillGray: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFDBDBDB" },
};

export const fillGray02: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};

export const fillGray03: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFA6A6A6" },
};

export const fillDarkGray: Fill = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FF626262" },
};

/** FONTES */
export const fontTitleHeader: Partial<Font> = {
  name: "Calibri",
  size: 12,
  color: whiteColor,
  bold: true,
};

export const fontNormal: Partial<Font> = { name: "Calibri", size: 10 };

export const fontToDarkFill: Partial<Font> = {
  name: "Calibri",
  size: 10,
  color: whiteColor,
};
export const fontBold: Partial<Font> = {
  name: "Calibri",
  size: 10,
  bold: true,
};



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/ReportStyles.ts